import Head from 'next/head';

import preload from '../../../styles/preload';

import { INextHead } from './types';

function NextHead({
  title,
  description,
  noIndex,
  imageUrl,
  canonicalPath,
  children,
  hasRawTitle,
}: INextHead) {
  const finalTitle = hasRawTitle ? title : `${title} | Quicktools by Picsart`;

  return (
    <Head>
      <meta charSet="utf-8" />
      <link rel="icon" sizes="16x16" href="/favicon16.png" type="image/png" />
      <link rel="icon" sizes="32x32" href="/favicon32.png" type="image/png" />
      <link rel="icon" sizes="16x16" href="/favicon16.svg" type="image/svg+xml" />
      <link rel="icon" sizes="32x32" href="/favicon32.svg" type="image/svg+xml" />
      <link
        rel="preload"
        as="font"
        href="https://cdn140.picsart.com/11276460729995425074.woff2"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        as="font"
        href="https://cdn140.picsart.com/74259325996804646481.woff2"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        as="font"
        href="https://cdn140.picsart.com/31072274683066559421.woff2"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        as="font"
        href="https://cdn140.picsart.com/96827950530598412943.woff2"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link href="https://tools.picsart.com/a/css/gilroyfonts.css" rel="stylesheet" />
      <style>{preload}</style>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
      <meta name="theme-color" content="#FFF" />
      <title>{finalTitle}</title>
      <meta name="description" content={description} />
      {noIndex || process.env.NX_ENV === 'preprod' ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <meta name="twitter:card" content="summary" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={imageUrl || 'https://cdn140.picsart.com/51081589361197808266.webp'}
      />
      {canonicalPath !== undefined && (
        <>
          <meta property="og:url" content={`https://tools.picsart.com/${canonicalPath}`} />
          <link rel="canonical" href={`https://tools.picsart.com/${canonicalPath}`} />
        </>
      )}
      {children}
    </Head>
  );
}

export default NextHead;
